<script setup lang="ts">
import { ROUTE_NAMES } from '~/constants/routes';
import { isAuction, type SaleItemEntity } from '~/types/sale.type';

// PROPS
const { sale } = defineProps({
    sale: { type: Object as PropType<SaleItemEntity>, required: true },
    embedded: { type: Boolean, default: false },
});

// COMPOSABLES
const { tt } = useTypedI18n();
const { statusSectionColor, isSeller } = isAuction(sale) ? useAuctionStatus(toRef(() => sale)) : useDirectSaleStatus(toRef(() => sale));
</script>

<template>
    <div class="divide-y divide-solid divide-neutral-200" :class="{ 'overflow-hidden rounded-xl border border-solid border-neutral-200': !embedded }">
        <div class="p-4 lg:p-6" :class="statusSectionColor">
            <SdpSalePanelStatusSection :sale="sale" />
        </div>

        <AdpSalePanelPlaceBidSection v-if="isAuction(sale)" :auction="sale" />
        <DsdpSalePanelActionsSection v-else :direct-sale="sale" />
        <SdpSalePanelVas v-if="!isSeller" :sale="sale" />
        <SdpSalePanelOrderSection v-if="sale.orderId" :order-id="sale.orderId" />

        <div v-if="isSeller" class="p-4 lg:p-6">
            <NuxtLinkLocale
                :to="{
                    name: ROUTE_NAMES.ACCOUNT_VEHICLE_STATS,
                    params: { saleType: isAuction(sale) ? 'Auction' : 'DirectSale', id: sale.id },
                }"
                class="text-primary flex items-center gap-2 text-sm font-medium"
            >
                <UIcon name="lucide:bar-chart-2" class="size-4" />
                {{ tt('sellerDashboard.viewStats') }}
            </NuxtLinkLocale>
        </div>
    </div>
</template>
